import { baseUrl } from './constant';
import axios from "axios";
import TokenService from "./token.service";

const instance = axios.create({
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

// set default headers
instance.interceptors.request.use(
    (config) => {
        const token = TokenService.getLocalAccessToken();
        if (config.url === "/o/token/coach") { //|| config.url == "/coach/password/forget"
            config.headers["Content-Type"] = 'application/x-www-form-urlencoded';
        } else {
            config.headers["Authorization"] = 'Bearer ' + token;
            config.headers["Accept"] = `application/json;version=${2}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// handle 401 errors
instance.interceptors.response.use(
    (res) => {
        res.ok = true;
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if ((originalConfig.url !== "/o/token/coach" && err.response) || originalConfig.url !== "/coach/password/forget") {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;
                const refreshToken = TokenService.getLocalRefreshToken();
                const body = new URLSearchParams();
                body.append('refresh_token', refreshToken);
                body.append('grant_type', "refresh_token");
                body.append('client_id', "r2OwoYcW5Ulhn8YDFFEInownoZCwSZPEXn9M0WHI");
                try {
                    const res = await instance.post("/o/token/coach", body);
                    TokenService.setAuthentication(res.data);
                    return instance(originalConfig);
                } catch (_error) {
                    return Promise.reject(_error);
                }
            }
        } else {
            return err.response;
        }
        return Promise.reject(err);
    }
);

// define the api
const api = instance;
export async function getRequest(url, params) {
    return api.get(url, {
        params: params
    });
}
export async function postRequest(url, body) {
    return api.post(url, body);
}
export async function patchRequest(url, body) {
    return api.patch(url, body);
}
export async function putRequest(url, params = null) {
    return api.put(url, params);
}
export async function deleteRequest(url) {
    return api.delete(url);
}
